var map = {
	"./UiButton.vue": 79776,
	"./UiCamera.vue": 74526,
	"./UiCameraDescription.vue": 13496,
	"./UiCameraFrame.vue": 61486,
	"./UiCheckBox.vue": 81102,
	"./UiControlsFrame.vue": 15535,
	"./UiDropDown.vue": 37798,
	"./UiForm.vue": 32035,
	"./UiFrame.vue": 23292,
	"./UiInput.vue": 41633,
	"./UiLoader.vue": 4702,
	"./UiPhoneCode.vue": 5923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70599;